import React, { useState } from "react";
import { useLocation } from "react-router-dom";

const EconomicInformationCompany = ({
  refIncomeOfLegalPerson,
  refTotal_indebtedness_of_the_financial_system,
  refTotal_monthly_commitment_of_the_financial_system,
  refCurrent_status_with_BCRA,
}) => {
  const data = useLocation();
  const [EconomicInformationCompany, setEconomicInformationCompany] = useState({
    IncomeOfLegalPerson:
      data.state.data.EconomicInformationCompany.IncomeOfLegalPerson || "",
    total_indebtedness_of_the_financial_system:
      data.state.data.EconomicInformationCompany
        .total_indebtedness_of_the_financial_system || "",
    total_monthly_commitment_of_the_financial_system:
      data.state.data.EconomicInformationCompany
        .total_monthly_commitment_of_the_financial_system || "",
    current_status_with_BCRA:
      data.state.data.EconomicInformationCompany.current_status_with_BCRA || "",
  });

  return (
    <div className="section">
      <div className="tittleupdatebox">
        <p className="tittleupdate">Informacion Economica</p>
      </div>
      <div className="displayinputupdatebox">
        <div className="inputboxupdate">
          <label className="tittleinputupdate_Lealtad">
            Monto transaccional anual:
          </label>
          <input
            ref={refIncomeOfLegalPerson}
            className="inputupdate"
            type="text"
            defaultValue={EconomicInformationCompany.IncomeOfLegalPerson}
            onChange={(e) =>
              setEconomicInformationCompany({
                ...EconomicInformationCompany,
                IncomeOfLegalPerson: e.target.value,
              })
            }
          />
        </div>
        <div className="inputboxupdate">
          <label className="tittleinputupdate_Lealtad">
            Total de endeudamiento del sistema financiero:
          </label>
          <input
            ref={refTotal_indebtedness_of_the_financial_system}
            className="inputupdate"
            type="text"
            defaultValue={
              EconomicInformationCompany.total_indebtedness_of_the_financial_system
            }
            onChange={(e) =>
              setEconomicInformationCompany({
                ...EconomicInformationCompany,
                total_indebtedness_of_the_financial_system: e.target.value,
              })
            }
          />
        </div>
      </div>
      <div className="displayinputupdatebox">
        <div className="inputboxupdate">
          <label className="tittleinputupdate_Lealtad">
            Total de compromiso mensual sistema financiero:
          </label>
          <input
            ref={refTotal_monthly_commitment_of_the_financial_system}
            className="inputupdate"
            type="text"
            defaultValue={
              EconomicInformationCompany.total_monthly_commitment_of_the_financial_system
            }
            onChange={(e) =>
              setEconomicInformationCompany({
                ...EconomicInformationCompany,
                total_monthly_commitment_of_the_financial_system:
                  e.target.value,
              })
            }
          />
        </div>
        <div className="inputboxupdate">
          <label className="tittleinputupdate_Lealtad">
            Situación vigente ante Bcra:
          </label>
          <input
            ref={refCurrent_status_with_BCRA}
            className="inputupdate"
            type="text"
            defaultValue={EconomicInformationCompany.current_status_with_BCRA}
            onChange={(e) =>
              setEconomicInformationCompany({
                ...EconomicInformationCompany,
                current_status_with_BCRA: e.target.value,
              })
            }
          />
        </div>
      </div>
    </div>
  );
};

export default EconomicInformationCompany;
